<template>
  <a href="#" class="item" @click.prevent="onClick">
    <span v-if="shouldShow">{{ hideMessage }}</span>
    <span v-if="!shouldShow">{{ showMessage }}</span>
    <i v-if="!shouldShow" class="toggle off icon"></i>
    <i v-if="shouldShow" class="toggle on icon"></i>
  </a>
</template>

<script>
// @flow
export default {
  name: 'show-hide',
  props: {
    shouldShow: {
      type: Boolean,
      default: () => false
    },
    showMessage: {
      type: String,
      default: () => ''
    },
    hideMessage: {
      type: String,
      default: () => ''
    },
    onClick: {
      type: Function,
      default: () => ''
    }
  }
}
</script>
